import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { PrimaryButton, Input } from "../components/ui-bits";
import { ShippingContainerIcon, ArrowLeftIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Missing reset token");
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    if (pw.length < 8) {
      toast.error("Min 8 characters");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset — sign in with your new password");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md border border-zinc-200 bg-white p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 bg-zinc-950 text-white flex items-center justify-center">
            <ShippingContainerIcon size={26} weight="bold" />
          </div>
          <div>
            <div className="font-heading font-black text-xl tracking-tight">CARGO/SCAN</div>
            <div className="overline mt-0.5">Set a new password</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-xs text-zinc-500 mb-1">New password (min 8 chars)</label>
            <Input data-testid="rp-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} className="w-full" />
          </div>
          <div>
            <label className="block text-xs text-zinc-500 mb-1">Confirm new password</label>
            <Input data-testid="rp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="w-full" />
          </div>
          <PrimaryButton type="submit" data-testid="rp-submit" disabled={loading || !token} className="w-full">
            {loading ? "Saving…" : "Reset password"}
          </PrimaryButton>
          <Link to="/login" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-950">
            <ArrowLeftIcon size={12} /> Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}
